import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=13665b3e&scoped=true&"
import script from "./activate.vue?vue&type=script&lang=js&"
export * from "./activate.vue?vue&type=script&lang=js&"
import style0 from "./activate.vue?vue&type=style&index=0&id=13665b3e&lang=scss&scoped=true&"
import style1 from "./activate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13665b3e",
  null
  
)

export default component.exports